import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/competition-stacking/actions';

class AddStackItem extends Component {
    onClick() {
        this.props.dispatch(Action.do('addItemToCompetitionStacking'));
    }

    render() {
        return (
            <button type="submit" onClick={::this.onClick} className="btn">
                Add Rule
            </button>
        );
    }
}

export default connect(() => ({}))(AddStackItem);
